import { render, staticRenderFns } from "./IndicatorExplanationModal.vue?vue&type=template&id=c3c44f02&scoped=true"
import script from "./IndicatorExplanationModal.vue?vue&type=script&lang=js"
export * from "./IndicatorExplanationModal.vue?vue&type=script&lang=js"
import style0 from "./IndicatorExplanationModal.vue?vue&type=style&index=0&id=c3c44f02&prod&scoped=true&lang=css"
import style1 from "./IndicatorExplanationModal.vue?vue&type=style&index=1&id=c3c44f02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c44f02",
  null
  
)

export default component.exports